var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showAvatar)?_c('div',{staticStyle:{"margin-right":"8px"},style:(_vm.computedStyle)},[(_vm.src)?_c('img',{style:({
      'width': _vm.size + 'px',
      'border-radius': _vm.roundness + 'px',
    }),attrs:{"src":_vm.src,"alt":"avatar"}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }